import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

export default function HomeImage() {
  const images = ["/img/hero.png", "/img/hero1.png", "/img/hero2.png"];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 2000); // Change every 4 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <section className="relative w-full overflow-hidden">
        <img
          src={images[current]}
          alt="Hero Banner"
          className="w-full h-auto transition-all duration-700"
        />

        {/* Dots */}
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2">
          {images.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-3 h-3 rounded-full ${
                current === index ? "bg-white" : "bg-white/50"
              }`}
            />
          ))}
        </div>
      </section>
    </>
  );
}
